const FrameData1 = [
  {
    GraphImg: "Frame-1.png",
    Creator: "Creator Earned",
    Eth: "8,097 ETH",
  },
  {
    GraphImg: "Frame-1.png",
    Creator: "Platform Earned",
    Eth: "8,097 ETH",
  },
  {
    GraphImg: "Frame-1.png",
    Creator: "Creators Count",
    Eth: "8,097",
  },
  {
    GraphImg: "Frame-1.png",
    Creator: "Standard User Count",
    Eth: "8,097 ETH",
  },
];
const FrameData2 = [
  {
    GraphImg: "Frame-2.png",
    AmountStash: "Amount of Stash Drops to Date",
    Eth: "4,927,540",
  },
  {
    GraphImg: "Frame-2.png",
    AmountStash: "Amount of Wavpool Drops to Date",
    Eth: "4,927,540",
  },
];
export { FrameData1, FrameData2 };
